import {
  IClient,
  IClinic,
  IClinicSearch,
  ICouponCode,
  ILogin,
  IOtp,
  IPhone,
  IRedeemCoupon,
  IUpdateCategory,
} from "@interfaces";
import axiosClient from "./axiosClient";

export const clinicApi = {
  clinics: (params: IClinicSearch) => {
    const url = "clinic/get";
    return axiosClient.get(url, { params });
  },
  clinic: (id: string) => {
    const url = `/clinic/get/${id}`;
    return axiosClient.get(url);
  },
  create: (params: IClinic) => {
    const url = `/clinic/create`;
    return axiosClient.post(url, params);
  },
  update: (params: IClinic, id: string) => {
    const url = `/clinic/update/${id}`;
    return axiosClient.put(url, params);
  },
  login: (params: ILogin) => {
    const url = `/clinic/login`;
    return axiosClient.put(url, params);
  },
  scanCode: (params: ICouponCode) => {
    const url = `/clinic/scan-code`;
    return axiosClient.post(url, params);
  },
  redeemedReject: (params: IRedeemCoupon) => {
    const url = `/clinic/redeemed-reject`;
    return axiosClient.post(url, params);
  },
  profile: () => {
    const url = `/profile`;
    return axiosClient.get(url);
  },
  category: (params: IUpdateCategory) => {
    const url = `/clinic/update-coupon-category`;
    return axiosClient.post(url, params);
  },
  requestOtp: (params: IPhone) => {
    const url = `/clinic/get-otp`;
    return axiosClient.post(url, params);
  },
  verify: (params: IOtp) => {
    const url = `/clinic/check-otp`;
    return axiosClient.post(url, params);
  },
  redeemCdicCoupon: (params: IRedeemCoupon) => {
    const url = `/clinic/redeem-coupon`;
    return axiosClient.post(url, params);
  },
  scanCdicCode: (params: ICouponCode) => {
    const url = `/clinic/scan-cdic-code`;
    return axiosClient.post(url, params);
  }
};
